import { Col, Container, Nav, Row, Tab } from "@themesberg/react-bootstrap";
import React, { useState } from "react";

import CustomerWiseDispatch from "./CustomerWiseDispatch";
import DealerWiseDispatch from "./DealerWiseDispatch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";

// import ServiceEngWiseReport from "./ServiceEngWiseReport";
// import AllServiceEntry from "./AllServiceEntry";

export default () => {
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  return (
    <article>
      <Container className="px-0">
        <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
          <Col className="d-block mb-4 mb-md-0">
            <h5 className="head mb-4">Dispatch Reports View</h5>
          </Col>
        </Row>
        {role === "dealer" ? (
          <div>
            <h5 className="mb-sm-3 mb-md-3">
              {/* <FontAwesomeIcon icon={faUser} className="me-2" />  */}
              
              Customer Wise
              Dispatch Report
            </h5>
            <CustomerWiseDispatch />
          </div>
        ) : role === "customer" ? (
          <div>
            <h5 className="mb-sm-3 mb-md-3">
              <FontAwesomeIcon icon={faUser} className="me-2" /> 
              
              {/* Dealer Wise Dispatch Report */}  
              {/* befroe its was displaying dealer wise */}
              Customer Wise
              Dispatch Report
            </h5>
            <DealerWiseDispatch />
          </div>
        ) : (
          <div>
            <Tab.Container defaultActiveKey="dispatchCustomer">
              <Row>
                <Col lg={12}>
                  <Nav fill variant="pills" className="flex-column flex-sm-row">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="dispatchCustomer"
                        className="mb-sm-3 mb-md-0 w-100"
                      >
                        <FontAwesomeIcon icon={faUser} className="me-2" />{" "}
                        Customer Wise Dispatch Report
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      {/* <Nav.Link
                        eventKey="dispatchDealer"
                        className="mb-sm-3 mb-md-0"
                      >
                        <FontAwesomeIcon icon={faUser} className="me-2" />
                        Dealer Wise Dispatch Report
                      </Nav.Link> */}
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="dispatchCustomer" className="py-4">
                      <CustomerWiseDispatch />
                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="dispatchDealer" className="py-4">
                      <DealerWiseDispatch />
                    </Tab.Pane> */}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        )}
      </Container>
    </article>
  );
};
